import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return

          this.processNode(node)
        })
      })
    })

    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  processNode(node) {
    const eventName = node.dataset.event
    if (!eventName) return

    // Build detail payload from data-* attributes
    const detail = { ...node.dataset }
    delete detail.event

    console.log(`event_bus_controller: dispatching ${eventName} - ${JSON.stringify(detail)}`)

    // Dispatch real browser event
    document.dispatchEvent(
      new CustomEvent(eventName, { detail })
    )

    // Clean up immediately
    node.remove()
  }
}